import { render, staticRenderFns } from "./MergeCustomersModal.vue?vue&type=template&id=2b13eac7&scoped=true&"
import script from "./MergeCustomersModal.vue?vue&type=script&lang=js&"
export * from "./MergeCustomersModal.vue?vue&type=script&lang=js&"
import style0 from "./MergeCustomersModal.vue?vue&type=style&index=0&id=2b13eac7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b13eac7",
  null
  
)

export default component.exports